import {AfterViewInit, Component, ElementRef, EventEmitter, Inject, Input, OnInit, Output, ViewChild} from '@angular/core';
import {
  AddGatewayResourceComponent,
  LeftpanelComponent,
  LoaderWithProgressComponent,
  ScheduleJobDialogComponent
} from '../leftpanel/leftpanel.component';
import {ConfService} from '../conf.service';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material';
import {Router} from '@angular/router';
import {KongService} from '../kong.service';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import { CronOptions } from 'cron-editor/lib/CronOptions';
import cronstrue from 'cronstrue';
import {SchedulerListenerService} from '../scheduler-listener.service';

declare let $;


@Component({
  selector: 'app-scheduler',
  templateUrl: './scheduler.component.html',
  styleUrls: ['./scheduler.component.scss']
})
export class SchedulerComponent implements OnInit {

  @Input() configurationObject: any;
  @Input() name: any;
  @Input() version: any;
  @Input() jobName = '';
  @Input() jobDescription = '';
  @Input() partner = localStorage.getItem('partner');
  @Input() account = localStorage.getItem('account');
  @Input() pkey = localStorage.getItem('partnerKey');
  @Input() apikey = localStorage.getItem('apikey');
  @Input() mode = '';
  @Input() wholeDataToReschedule: any;
  @Input() startDateActualFormat: any;
  @Input() endDateActualFormat: any;

  @Output() close: EventEmitter<any> = new EventEmitter();

  @ViewChild('dt1') intervalStartDate: ElementRef;
  @ViewChild('dt2') intervalEndDate: ElementRef;


  payloadToSchedule = [];

  scheduleType = '';

  scheduleTypes = ['Interval', 'Date', 'Cron'];
  startDate = '';
  endDate = '';

  intervalConfigurations = {
    weeks: 0,
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  };

  dateConfigurations = {};

  startDateFormat = '';
  endDateFormat = '';

  // repeatTypes = ['None', 'Every Second', 'Every Minute', 'Every Hour', 'Every Day', 'Every Week', 'Custom'];

  repeatTypes = [
    {
      name: 'None',
      type: 'Date',
      toolTip: 'Job will be executed once at the specified date and time'
    },
    {
      name: 'Every Second',
      type: 'Interval',
      toolTip: 'Job will be executed for every second from the start date and time'
    },
    {
      name: 'Every Minute',
      type: 'Interval',
      toolTip: 'Job will be executed for every minute from the start date and time'
    },
    {
      name: 'Every Hour',
      type: 'Interval',
      toolTip: 'Job will be executed for every hour from the start date and time'
    },
    {
      name: 'Every Day',
      type: 'Interval',
      toolTip: 'Job will be executed for every day from the start date and time'
    },
    {
      name: 'Every Week',
      type: 'Interval',
      toolTip: 'Job will be executed for every week from the start date and time'
    },
    {
      name: 'Custom',
      type: 'Cron',
      toolTip: 'Job will be scheduled according to the CRON expression configured'
    },
  ];

  selectedRepeatType = 'None';
  cronExpression = '* * * * * * *';
  timezone = 'Asia/Kolkata';
  timeZones: any;
  decodedCRON = '';
  scheduledJobs: any;
  executors: any;
  executorsDropdown = [];

  selectedExecutor = [];

    settings = {
        text: 'Select an API to Schedule',
        // selectAllText: 'Select All',
        // unSelectAllText: 'Unselect All',
        singleSelection: true,
        enableCheckAll: false,
        enableSearchFilter: true,
        autoPosition: true
    };


  constructor(private platform: LeftpanelComponent, private confPost: ConfService, private dialog: MatDialog, private router: Router, private schedulerListenerInstance: SchedulerListenerService) { }

  async ngOnInit() {

    if (this.platform.loadingForTheFirstTime === true && this.platform.loadingForTheFirstTimeCompleted === false) {
      this.platform.initialisePlatform();
    }

    if (this.name && this.version) {
        const selectedExecutor = {
            itemName: this.name + ' (' + this.version + ')'
        };
        this.selectedExecutor.push(selectedExecutor);
    }

    if (this.platform.leftpanelData) {
        this.executors = this.platform.leftpanelData;
    } else {
        await this.platform.getExecutorsForPartnerAccount();
        this.executors = this.platform.leftpanelData;
    }
      if (this.executors) {
        for (let i = 0; i < this.executors.length; i++) {
          if (this.executors[i] && this.executors[i]['executor_type'] !== 'API') {
            const tempObj = {};
            tempObj['id'] = i;
            tempObj['itemName'] = this.executors[i]['executor_name'] + ' (' + this.executors[i]['executor_version'] + ')'
            this.executorsDropdown.push(tempObj);
          }
        }
    }

    if (this.platform.scheduledJobs && this.platform.scheduledJobs !== null && this.platform.scheduledJobs !== undefined && this.platform.scheduledJobs !== '') {
      this.scheduledJobs = this.platform.scheduledJobs;
      this.appendCRONJobs();
    } else {
      Promise.resolve(this.platform.getScheduledJobs()).then(response => {
        this.scheduledJobs = this.platform.scheduledJobs;
        this.appendCRONJobs();
      }, error => {
      });
    }

    await Promise.resolve(this.platform.getTimeZones()).then(response => {
      this.timeZones = this.platform.timeZones;
    }, error => {
      this.close.emit();
    });

    this.dateConfigurations['startDate'] = this.startDateActualFormat;
    this.dateConfigurations['endDate'] = this.endDateActualFormat;

    if (this.configurationObject['type'] === 'interval') {
      this.scheduleType = 'Interval';
      if (this.configurationObject['configurations'].hasOwnProperty('seconds')) {
        this.selectedRepeatType = 'Every Second';
      } else if (this.configurationObject['configurations'].hasOwnProperty('minutes')) {
        this.selectedRepeatType = 'Every Minute';
      } else if (this.configurationObject['configurations'].hasOwnProperty('hours')) {
        this.selectedRepeatType = 'Every Hour';
      } else if (this.configurationObject['configurations'].hasOwnProperty('days')) {
        this.selectedRepeatType = 'Every Day';
      } else if (this.configurationObject['configurations'].hasOwnProperty('weeks')) {
        this.selectedRepeatType = 'Every Week';
      }
      if (this.configurationObject['configurations'].hasOwnProperty('start_date')) {
        this.startDate = this.configurationObject['configurations']['start_date'];
        this.timezone = this.configurationObject['configurations']['timezone'];
        // this.dateConfigurations['startDate'] = this.startDateActualFormat;
      }
      if (this.configurationObject['configurations'].hasOwnProperty('end_date')) {
        this.endDate = this.configurationObject['configurations']['end_date'];
        // this.dateConfigurations['endDate'] = this.endDateActualFormat;
        this.timezone = this.configurationObject['configurations']['timezone'];
      }
      this.intervalConfigurations = this.configurationObject['configurations'];
    } else if (this.configurationObject['type'] === 'date') {
      this.scheduleType = 'Date';
      this.selectedRepeatType = 'None';
      this.startDate = this.configurationObject['configurations']['run_date'];
      this.timezone = this.configurationObject['configurations']['timezone'];
      this.dateConfigurations['startDate'] = this.startDateActualFormat;
    } else if (this.configurationObject['type'] === 'cron') {
      this.scheduleType = 'Cron';
      this.cronExpression = this.configurationObject['cron_expression'];
      this.selectedRepeatType = this.cronExpression;
      this.decodedCRON = cronstrue.toString(this.cronExpression, {verbose: true});
    }
  }

    setSelectedExecutor(event) {
      if (event) {
          const executorSplit = event['itemName'].split(' (');
          this.name = executorSplit[0];
          this.version = executorSplit[1].substr(0, executorSplit[1].length - 1);
      }
    }

  appendCRONJobs() {
    for (const job of this.scheduledJobs) {
      if (job['trigger']['type'] === 'cron') {
        if (job['trigger'].hasOwnProperty('cron_expression')) {
          const object = {
            name: job['trigger']['cron_expression'],
            type: 'Cron',
            toolTip: cronstrue.toString(job['trigger']['cron_expression'], {verbose: true})
          };
          if (this.repeatTypes.filter(element => element.name === object['name']).length === 0) {
            this.repeatTypes.push(object);
          }
        }
      }
    }
  }


  setRepeatType(event) {
    this.selectedRepeatType = event;
    const selectedObject = this.repeatTypes.filter((element) => element.name === event);
    if (event === 'None') {
      this.scheduleType = 'Date';
    } else if (event === 'Every Second' || event === 'Every Minute' || event === 'Every Second' ||
        event === 'Every Day' || event === 'Every Week') {
      this.scheduleType = 'Interval';
    } else if (event === 'Custom') {
      this.scheduleType = 'Cron';
      const dialogRef = this.dialog.open(CronScheduleJobDialogComponent, {
        width: 'auto',
        data: {
          cronExpression: this.cronExpression
        }
      });

      dialogRef.afterClosed().subscribe(response => {
        if(response) {
          this.cronExpression = response;
          this.decodedCRON = cronstrue.toString(this.cronExpression, {verbose: true});
          const CRONObject = {
            name: this.cronExpression,
            type: 'Cron',
            toolTip: this.decodedCRON
          };
          this.selectedRepeatType = this.cronExpression;
          if (this.repeatTypes.filter(element => element.name === CRONObject['name']).length === 0) {
            this.repeatTypes.push(CRONObject);
          }
        }
      });

    } else {
      // We'll be considering this as the user configured CRON Jobs
      this.selectedRepeatType = selectedObject[0]['name'];
      this.scheduleType = selectedObject[0]['type'];
      this.cronExpression = selectedObject[0]['name'];
      this.decodedCRON = selectedObject[0]['toolTip'];
    }
  }

  returnInRequiredDateFormat(date): string {
    const year = new Date(date).getFullYear();
    const month = new Date(date).getMonth() + 1;
    const day = new Date(date).getDate();
    const hour = new Date(date).getHours();
    const minutes = new Date(date).getMinutes();
    const seconds = new Date(date).getSeconds();
    return year + '-' + month + '-' + day + ' ' + hour + ':' + minutes + ':' + seconds;
  }

  scheduleJob() {

    let clickedMessage = '';

    if (this.mode === 'schedule') {
        clickedMessage = 'scheduler_schedule_clicked';
    } else if (this.mode === 'reschedule') {
        clickedMessage = 'scheduler_reschedule_clicked';
    } else if (this.mode === 'edit') {
        clickedMessage = 'scheduler_edit_clicked';
    }

    Promise.resolve(this.platform.generateActionPayloadForAudit(false, clickedMessage, 'INFO', 200, 'OK', '', '', '', this.router.url)).then(response => {
      const payloadToSend = {
        actions: response
      };
      this.schedulerListenerInstance.schedulerListener.emit({
        type: 'audit',
        id: localStorage.getItem('IdOfSession'),
        payload: payloadToSend
      });
    });
    if (this.jobName !== '' && this.jobName !== null && this.jobName !== undefined) {
      if (this.scheduleType === 'Interval') {
        if (this.dateConfigurations['startDate'] && this.dateConfigurations['startDate'] !== '') {
          this.startDate = this.returnInRequiredDateFormat(this.dateConfigurations['startDate']);
        }
        if (this.dateConfigurations['endDate'] && this.dateConfigurations['endDate'] !== '') {
          this.endDate = this.returnInRequiredDateFormat(this.dateConfigurations['endDate']);
        }
        this.constructPayloadAndSchedule();
      } else if (this.scheduleType === 'Date') {
        if (this.dateConfigurations['startDate'] && this.dateConfigurations['startDate'] !== '') {
          this.startDate = this.returnInRequiredDateFormat(this.dateConfigurations['startDate']);
          this.constructPayloadAndSchedule();
        } else {
          this.platform.openSnackBar('Please provide a date to schedule the job.', 'Error', {
            duration: 7000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
          });
        }
      } else if (this.scheduleType === 'Cron') {
        if (this.cronExpression && this.cronExpression !== '') {
          if (this.dateConfigurations['startDate'] && this.dateConfigurations['startDate'] !== '') {
            this.startDate = this.returnInRequiredDateFormat(this.dateConfigurations['startDate']);
          }
          if (this.dateConfigurations['endDate'] && this.dateConfigurations['endDate'] !== '') {
            this.endDate = this.returnInRequiredDateFormat(this.dateConfigurations['endDate']);
          }
          this.constructPayloadAndSchedule();
        } else {
          this.platform.openSnackBar('You have selected custom repeat type but the cron expression seems to be empty. Please specify a valid cron job', 'Error', {
            duration: 7000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
          });
        }
      }
    } else {
      this.platform.openSnackBar('Please enter a job name.', 'Error', {
        duration: 7000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
    }
  }

  constructPayloadAndSchedule() {

    if (
        ((new Date(this.startDate) < new Date(this.endDate)) && this.selectedRepeatType !== "None") ||
        (this.startDate && this.selectedRepeatType === 'None')
    ) {

      let successMessage = '';
      let failedMessage = '';

      if (this.mode === 'schedule') {
        successMessage = 'scheduler_schedule_success';
      } else if (this.mode === 'reschedule') {
        successMessage = 'scheduler_reschedule_success';
      } else if (this.mode === 'edit') {
        successMessage = 'scheduler_edit_success';
      }

      if (this.mode === 'schedule') {
        failedMessage = 'scheduler_schedule_failed';
      } else if (this.mode === 'reschedule') {
        failedMessage = 'scheduler_reschedule_failed';
      } else if (this.mode === 'edit') {
        failedMessage = 'scheduler_edit_success';
      }

      this.payloadToSchedule = [];
      const payload = {};
      payload['name'] = this.partner + '>' + this.account + '>' + this.name + '>' + this.version;
      payload['job_name'] = this.jobName;
      payload['description'] = this.jobDescription;
      const triggerObject = {
        type: '',
        configurations: {}
      };
      triggerObject['type'] = this.scheduleType.toLowerCase();
      if (this.scheduleType === 'Interval') {
        if (this.startDate && this.startDate !== '') {
          triggerObject['start_date_actual_format'] = this.dateConfigurations['startDate'];
          triggerObject['configurations']['start_date'] = this.startDate;
          triggerObject['configurations']['timezone'] = this.timezone;
        }
        if (this.endDate && this.endDate !== '') {
          triggerObject['end_date_actual_format'] = this.dateConfigurations['endDate'];
          triggerObject['configurations']['end_date'] = this.endDate;
          triggerObject['configurations']['timezone'] = this.timezone;
        }
        switch (this.selectedRepeatType) {
          case 'Every Second':
            triggerObject['configurations']['seconds'] = 1;
            break;
          case 'Every Minute':
            triggerObject['configurations']['minutes'] = 1;
            break;
          case 'Every Hour':
            triggerObject['configurations']['hours'] = 1;
            break;
          case 'Every Day':
            triggerObject['configurations']['days'] = 1;
            break;
          case 'Every Week':
            triggerObject['configurations']['weeks'] = 1;
            break;
        }
      } else if (this.scheduleType === 'Date') {
        if (this.startDate && this.startDate !== '') {
          triggerObject['start_date_actual_format'] = this.dateConfigurations['startDate'];
          triggerObject['configurations']['run_date'] = this.startDate;
          triggerObject['configurations']['timezone'] = this.timezone;
        }
      } else if (this.scheduleType === 'Cron') {
        this.cronExpression = this.cronExpression.replace('?', '*');
        const expressionArray = this.cronExpression.split(' ');
        const configurationObject = {
          second: expressionArray[0],
          minute: expressionArray[1],
          hour: expressionArray[2],
          day: expressionArray[3],
          month: expressionArray[4],
          'day_of_week': expressionArray[5],
          year: expressionArray[6],
          timezone: this.timezone,
          start_date: this.startDate,
          end_date: this.endDate
        };
        triggerObject['is_expression'] = false;
        triggerObject['cron_expression'] = this.cronExpression;
        triggerObject['start_date_actual_format'] = this.dateConfigurations['startDate'];
        triggerObject['end_date_actual_format'] = this.dateConfigurations['endDate'];
        triggerObject['configurations'] = configurationObject;
        // triggerObject['configurations']['expr'] = this.cronExpression;
        // triggerObject['configurations']['timezone'] = this.timezone;
      }
      payload['trigger'] = triggerObject;
      const executors = [];
      executors[0] = {
        'partner': this.partner,
        'account': this.account,
        'executor_name': this.name,
        'executor_version': this.version,
        'pkey': this.pkey
      };
      payload['executors'] = executors;
      payload['partner'] = this.partner;
      payload['account'] = this.account;
      payload['created_at'] = Date.now();
      payload['updated_at'] = Date.now();

      const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
        maxWidth: '95vw',
        maxHeight: '60vh',
      });
      if (this.mode === 'schedule') {
        this.payloadToSchedule.push(payload);
        this.confPost.scheduleJob(this.partner, this.account, this.pkey, this.apikey, this.payloadToSchedule).subscribe(data => {
          Promise.resolve(this.platform.generateActionPayloadForAudit(false, successMessage, 'INFO', data.status, data.statusText, '', {
            partner: this.partner,
            account: this.account,
            payloadToSchedule: this.payloadToSchedule
          }, data, this.router.url)).then(response => {
            const payloadToSend = {
              actions: response
            };
            this.schedulerListenerInstance.schedulerListener.emit({
              type: 'audit',
              id: localStorage.getItem('IdOfSession'),
              payload: payloadToSend
            });
          });
          this.platform.openSnackBar('Job Scheduled Successfully.', 'Success', {
            duration: 5000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
          });
          loaderDialog.close();
          this.close.emit();
        }, error => {
          Promise.resolve(this.platform.generateActionPayloadForAudit(true, failedMessage, 'ERROR', error.status, error.statusText, this.platform.returnErrorMessage(error), {
            partner: this.partner,
            account: this.account,
            payloadToSchedule: this.payloadToSchedule
          }, error, this.router.url)).then(response => {
            const payloadToSend = {
              actions: response
            };
            this.schedulerListenerInstance.schedulerListener.emit({
              type: 'audit',
              id: localStorage.getItem('IdOfSession'),
              payload: payloadToSend
            });
          });
          loaderDialog.close();
          this.platform.handleErrorGracefully(error, 'Error while scheduling job. Please try again after sometime.');
        });
      } else if (this.mode === 'edit' || this.mode === 'reschedule') {
        if (this.wholeDataToReschedule) {
          this.wholeDataToReschedule['trigger'] = triggerObject;
          if (this.mode === 'edit') {
            this.wholeDataToReschedule['name'] = this.partner + '>' + this.account + '>' + this.name + '>' + this.version;
            this.wholeDataToReschedule['executors'][0]['executor_name'] = this.name;
            this.wholeDataToReschedule['executors'][0]['executor_version'] = this.version;
          }
          this.wholeDataToReschedule['updated_at'] = Date.now();
        }
        this.confPost.rescheduleJob(this.partner, this.account, this.pkey, this.apikey, this.wholeDataToReschedule['job_meta']['id'], this.wholeDataToReschedule).subscribe(data => {
          Promise.resolve(this.platform.generateActionPayloadForAudit(false, successMessage, 'INFO', data.status, data.statusText, '', {
            partner: this.partner,
            account: this.account,
            id: this.wholeDataToReschedule['job_meta']['id'],
            wholeDataToReschedule: this.wholeDataToReschedule
          }, data, this.router.url)).then(response => {
            const payloadToSend = {
              actions: response
            };
            this.schedulerListenerInstance.schedulerListener.emit({
              type: 'audit',
              id: localStorage.getItem('IdOfSession'),
              payload: payloadToSend
            });
          });
          this.platform.openSnackBar('Job Recheduled Successfully.', 'Success', {
            duration: 5000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
          });
          loaderDialog.close();
          this.close.emit();
        }, error => {
          Promise.resolve(this.platform.generateActionPayloadForAudit(true, failedMessage, 'ERROR', error.status, error.statusText, this.platform.returnErrorMessage(error), {
            partner: this.partner,
            account: this.account,
            id: this.wholeDataToReschedule['job_meta']['id'],
            wholeDataToReschedule: this.wholeDataToReschedule
          }, error, this.router.url)).then(response => {
            const payloadToSend = {
              actions: response
            };
            this.schedulerListenerInstance.schedulerListener.emit({
              type: 'audit',
              id: localStorage.getItem('IdOfSession'),
              payload: payloadToSend
            });
          });
          this.platform.handleErrorGracefully(error, 'Error while scheduling job. Please try again after sometime.');
          loaderDialog.close();
        });
      }
    } else {
      if (this.selectedRepeatType !== 'None') {
        this.platform.openSnackBar('Please check the start date and end date.', 'Success', {
          duration: 5000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
      }
    }
  }

}

@Component({
  selector: 'cron-schedule-job-dialog',
  templateUrl: 'cron-schedule-job-dialog.component.html',
  styleUrls: ['cron-schedule-job-dialog.component.css']
})

export class CronScheduleJobDialogComponent implements OnInit {

    cronExpression = '* * * * * * *';
    isCronDisabled = false;

    // 5 segment
  //   cronOptions: CronOptions = {
  //   formInputClass: 'form-control cron-editor-input',
  //   formSelectClass: 'form-control cron-editor-select',
  //   formRadioClass: 'cron-editor-radio',
  //   formCheckboxClass: 'cron-editor-checkbox',
  //
  //   defaultTime: '10:00:00',
  //   use24HourTime: true,
  //
  //   hideMinutesTab: false,
  //   hideHourlyTab: false,
  //   hideDailyTab: false,
  //   hideWeeklyTab: false,
  //   hideMonthlyTab: false,
  //   hideYearlyTab: false,
  //   hideAdvancedTab: false,
  //
  //   hideSeconds: true,
  //   removeSeconds: true,
  //   removeYears: true
  // };

  cronOptions: CronOptions = {
    formInputClass: 'form-control cron-editor-input',
    formSelectClass: 'form-control cron-editor-select',
    formRadioClass: 'cron-editor-radio',
    formCheckboxClass: 'cron-editor-checkbox',

    defaultTime: '10:00:00',
    use24HourTime: true,

    hideMinutesTab: false,
    hideHourlyTab: false,
    hideDailyTab: false,
    hideWeeklyTab: false,
    hideMonthlyTab: false,
    hideYearlyTab: false,
    hideAdvancedTab: false,

    hideSeconds: false,
    removeSeconds: false,
    removeYears: false
  };

  constructor(private dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: any, public platform: LeftpanelComponent, public dialogRef: MatDialogRef<CronScheduleJobDialogComponent>, private _formBuilder: FormBuilder, public confPost: ConfService, public router: Router, public kongService: KongService) {
    dialogRef.disableClose = true;
  }

  ngOnInit() {

    this.cronExpression = this.data['cronExpression'];
    // this.myGroup = this._formBuilder.group({
    //   cronForm: new FormControl('0 0 1/1 * *')
    // });

  }

  close() {
    this.dialogRef.close(this.cronExpression);
  }

  closeDialog() {
    this.dialogRef.close();
  }
}

